import { SvgIcon } from "@mui/material";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
const SpeakingIcon = () => {
  return (
    <div className="speaking-icon pulse">
      <SvgIcon
        component={RecordVoiceOverIcon}
        // className="pulse"
        fontSize="medium"
      />
    </div>
  );
};
export default SpeakingIcon;
